import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toHandlers as _toHandlers, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { style: {"padding":"8px","width":"100%"} }
const _hoisted_4 = {
  class: "material-div",
  style: {"padding-top":"8px","height":"100%","max-height":"40vh"}
}
const _hoisted_5 = { style: {"height":"100%"} }
const _hoisted_6 = {
  key: 0,
  class: "spin"
}
const _hoisted_7 = {
  key: 0,
  class: "top-badge ion-text-center",
  style: {"top":"0","width":"100%","height":"100%"}
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "spin"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!
  const _component_ion_fab = _resolveComponent("ion-fab")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_reorder = _resolveComponent("ion-reorder")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_reorder_group = _resolveComponent("ion-reorder-group")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_footer = _resolveComponent("ion-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  slot: "icon-only",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal({}, !_ctx.isPreview)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_title, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, null, {
                  default: _withCtx(() => _cache[17] || (_cache[17] = [
                    _createElementVNode("h2", { style: {"font-size":"20px"} }, "AchieveSLP", -1),
                    _createElementVNode("p", null, [
                      _createElementVNode("small", null, "This tool will be disabled at 23:59 the day after this event.")
                    ], -1)
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_select, {
              slot: "end",
              interface: "popover",
              modelValue: _ctx.selectedClientId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedClientId) = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allClients, (client) => {
                  return (_openBlock(), _createBlock(_component_ion_select_option, {
                    key: client.id,
                    value: client.id
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(client.fullName), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_ion_toolbar, { style: {"--min-height":"32px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_segment, {
              mode: "ios",
              modelValue: _ctx.currStep,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currStep) = $event)),
              scrollable: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_segment_button, { value: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => _cache[18] || (_cache[18] = [
                        _createElementVNode("p", null, "Key strength", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_segment_button, {
                  value: 2,
                  disabled: _ctx.recommendedProfessions.length == 0
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => _cache[19] || (_cache[19] = [
                        _createElementVNode("p", null, "Professions", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_ion_segment_button, {
                  value: 3,
                  disabled: _ctx.recommendedProfessions.length == 0
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => _cache[20] || (_cache[20] = [
                        _createElementVNode("p", null, "Claims", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_ion_segment_button, {
                  value: 4,
                  disabled: _ctx.recommendedProfessions.length == 0
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => _cache[21] || (_cache[21] = [
                        _createElementVNode("p", null, "Elaborate", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_ion_segment_button, {
                  value: 5,
                  disabled: _ctx.recommendedProfessions.length == 0
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => _cache[22] || (_cache[22] = [
                        _createElementVNode("p", null, "Finalize", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(_component_ion_toolbar, { style: {"--min-height":"32px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_segment, {
              mode: "ios",
              modelValue: _ctx.selectedSLPType,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedSLPType) = $event)),
              onIonChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.checkGPTAction()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_segment_button, { value: "original" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => _cache[23] || (_cache[23] = [
                        _createElementVNode("p", null, "Original", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_segment_button, { value: "gpt" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, {
                      class: "ion-text-wrap",
                      style: {"line-height":"1"}
                    }, {
                      default: _withCtx(() => _cache[24] || (_cache[24] = [
                        _createElementVNode("p", null, "ChatGPT", -1),
                        _createElementVNode("small", { style: {"text-transform":"none"} }, "(Availability subject to geography)", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.currStep == 5]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { fullscreen: true }, {
      default: _withCtx(() => [
        (_ctx.loading || _ctx.loadingProgram)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_ion_spinner)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _withDirectives(_createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_ion_textarea, {
                    placeholder: "By writing and/or tags, describe your strengths, passions, and habits as specifically as possible",
                    fill: "outline",
                    modelValue: _ctx.userSLP.userInputText,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.userSLP.userInputText) = $event)),
                    rows: 3,
                    "auto-grow": true
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode(_component_ion_toolbar, { style: {"--min-height":"24px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_segment, {
                      class: "filter-group-segment",
                      mode: "md",
                      modelValue: _ctx.selectedFilterGroup,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedFilterGroup) = $event)),
                      scrollable: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_segment_button, { value: "Passion" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                              default: _withCtx(() => _cache[25] || (_cache[25] = [
                                _createTextVNode("Passion")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_segment_button, { value: "Subject" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                              default: _withCtx(() => _cache[26] || (_cache[26] = [
                                _createTextVNode("Subject")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.passionTags, (tag, i) => {
                    return _withDirectives((_openBlock(), _createBlock(_component_ion_chip, {
                      key: i,
                      onClick: ($event: any) => (_ctx.toggleSelectedTag(tag.id, tag.text)),
                      class: _normalizeClass({ 'active-tag': _ctx.userSLP.tagId == tag.id })
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tag.text), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick", "class"])), [
                      [_vShow, _ctx.selectedFilterGroup == 'Passion']
                    ])
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subjectTags, (tag, i) => {
                    return _withDirectives((_openBlock(), _createBlock(_component_ion_chip, {
                      key: i,
                      onClick: ($event: any) => (_ctx.toggleSelectedTag(tag.id, tag.text)),
                      class: _normalizeClass({ 'active-tag': _ctx.userSLP.tagId == tag.id })
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tag.text), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick", "class"])), [
                      [_vShow, _ctx.selectedFilterGroup == 'Subject']
                    ])
                  }), 128)),
                  _createVNode(_component_ion_chip, {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toggleSelectedTag(_ctx.tagObjOther.id, _ctx.tagObjOther.text))),
                    class: _normalizeClass({ 'active-tag': _ctx.userSLP.tagId == _ctx.tagObjOther.id })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.tagObjOther.text), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["class"])
                ])
              ], 512), [
                [_vShow, _ctx.currStep == 1]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_5, [
                (_ctx.userSLP.waitingGPTResp)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_ion_spinner)
                    ]))
                  : (_openBlock(), _createBlock(_component_swiper, {
                      key: 1,
                      navigation: true,
                      class: "card-slides",
                      id: "card-swiper-slides",
                      effect: 'cards',
                      grabCursor: true,
                      modules: _ctx.modules
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recommendedProfessions, (profession) => {
                          return (_openBlock(), _createBlock(_component_swiper_slide, {
                            class: _normalizeClass(["card-slide", { 'highlighted-border': _ctx.isProfessionSelected(profession) }]),
                            key: profession.id,
                            "data-profession-id": profession.id
                          }, {
                            default: _withCtx(() => [
                              (profession.imgLink && profession.imgLink != 'N/A')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createElementVNode("img", {
                                      style: {"max-width":"100%","object-fit":"cover","height":"100%","filter":"brightness(60%)"},
                                      src: profession.imgLink
                                    }, null, 8, _hoisted_8)
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_ion_row, { style: {"text-shadow":"3px 3px 15px black"} }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_col, { size: "12" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h1", null, [
                                        _createTextVNode(_toDisplayString(profession.name), 1),
                                        _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
                                        _createElementVNode("small", null, _toDisplayString(profession.nameChinese), 1)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_col, { size: "12" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_button, {
                                        size: "small",
                                        color: "light",
                                        class: "no-text-transform",
                                        onClick: ($event: any) => (_ctx.openProfessionModal(profession.id))
                                      }, {
                                        default: _withCtx(() => _cache[28] || (_cache[28] = [
                                          _createTextVNode(" Details ")
                                        ])),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_fab, {
                                slot: "fixed",
                                vertical: "top",
                                horizontal: "end"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_fab_button, _mergeProps(_toHandlers({ [_ctx.isMobileWeb() ? 'touchstart' : 'click']: () => { _ctx.onThumbsUp(profession) } }), {
                                    style: {"--background":"transparent"},
                                    color: profession.imgLink ? 'light' : undefined
                                  }), {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        size: "large",
                                        icon: _ctx.isProfessionSelected(profession) ? _ctx.thumbsUp : _ctx.thumbsUpOutline
                                      }, null, 8, ["icon"])
                                    ]),
                                    _: 2
                                  }, 1040, ["color"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["class", "data-profession-id"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modules"]))
              ], 512), [
                [_vShow, _ctx.currStep == 2]
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _createVNode(_component_ion_list, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, { lines: "full" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "ion-no-margin ion-text-wrap" }, {
                          default: _withCtx(() => _cache[29] || (_cache[29] = [
                            _createElementVNode("h3", null, [
                              _createElementVNode("i", null, [
                                _createTextVNode("Please select and prioritize (drag & move) "),
                                _createElementVNode("b", null, "at most 3 claims")
                              ])
                            ], -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_reorder_group, {
                      onIonItemReorder: _cache[8] || (_cache[8] = ($event: any) => (_ctx.doReorder($event, _ctx.chosenClaims))),
                      disabled: _ctx.isReadonly()
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chosenClaims, (clm, i) => {
                          return (_openBlock(), _createBlock(_component_ion_item, {
                            lines: "full",
                            key: clm.id,
                            style: {"--min-height":"55px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_reorder, {
                                mode: "ios",
                                slot: "start"
                              }),
                              _createVNode(_component_ion_checkbox, {
                                justify: "space-between",
                                labelPlacement: "start",
                                "onUpdate:modelValue": ($event: any) => (_ctx.onCheckClaim($event, clm)),
                                modelValue: _ctx.chosenClaims.find(c => c.id == clm.id) != null,
                                disabled: _ctx.isReadonly()
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, {
                                    class: "ion-text-wrap",
                                    style: {"opacity":"1"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(i+1) + ". " + _toDisplayString(clm.text), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["onUpdate:modelValue", "modelValue", "disabled"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredClaims(), (clm) => {
                      return (_openBlock(), _createBlock(_component_ion_item, {
                        lines: "full",
                        key: clm.id,
                        style: {"--min-height":"55px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_checkbox, {
                            justify: "start",
                            labelPlacement: "end",
                            "onUpdate:modelValue": ($event: any) => (_ctx.onCheckClaim($event, clm)),
                            modelValue: _ctx.chosenClaims.find(c => c.id == clm.id) != null
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(clm.text), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["onUpdate:modelValue", "modelValue"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    _createVNode(_component_ion_item, {
                      lines: "full",
                      style: {"--min-height":"32px"},
                      button: "",
                      detail: "",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openNewClaimPrompt()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "start",
                          icon: _ctx.add,
                          style: {"margin-right":"12px"}
                        }, null, 8, ["icon"]),
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withCtx(() => _cache[30] || (_cache[30] = [
                            _createTextVNode("Add a new claim")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _ctx.currStep == 3]
              ]),
              _withDirectives(_createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chosenClaims, (clm, idx) => {
                  return (_openBlock(), _createBlock(_component_ion_card, { key: idx }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_content, { style: {"color":"var(--ion-color-dark)"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_textarea, {
                            fill: "solid",
                            modelValue: clm.userText,
                            "onUpdate:modelValue": ($event: any) => ((clm.userText) = $event),
                            readonly: _ctx.isReadonly()
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"]),
                          _createVNode(_component_ion_textarea, {
                            fill: "solid",
                            modelValue: clm.userElaboration,
                            "onUpdate:modelValue": ($event: any) => ((clm.userElaboration) = $event),
                            rows: 12,
                            readonly: _ctx.isReadonly()
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ], 512), [
                [_vShow, _ctx.currStep == 4]
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _createVNode(_component_ion_grid, null, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_ion_textarea, {
                      style: {"font-size":"14px","color":"#737373"},
                      fill: "solid",
                      "auto-grow": true,
                      counter: true,
                      maxlength: Infinity,
                      "counter-formatter": _ctx.getCounterFormatterTextOriginal,
                      modelValue: _ctx.userSLP.original,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.userSLP.original) = $event)),
                      readonly: ""
                    }, null, 8, ["counter-formatter", "modelValue"]), [
                      [_vShow, _ctx.selectedSLPType == 'original']
                    ]),
                    (_ctx.selectedSLPType == 'gpt')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          (_ctx.userSLP.waitingGPTResp)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createVNode(_component_ion_spinner)
                              ]))
                            : (_openBlock(), _createBlock(_component_ion_textarea, {
                                key: 1,
                                fill: "outline",
                                "auto-grow": true,
                                counter: true,
                                maxlength: Infinity,
                                "counter-formatter": _ctx.getCounterFormatterTextGPT,
                                readonly: _ctx.isReadonly(),
                                modelValue: _ctx.userSLP.gpt,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.userSLP.gpt) = $event))
                              }, null, 8, ["counter-formatter", "readonly", "modelValue"]))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _ctx.currStep == 5]
              ])
            ]))
      ]),
      _: 1
    }),
    _createVNode(_component_ion_footer, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", null, [
          _createVNode(_component_ion_card, { style: {"margin-top":"0","border-radius":"16px"} }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_ion_chip, { style: {"height":"24px","font-size":"11px","margin":"0"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_avatar, { style: {"height":"20px","width":"20px"} }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: require('@/assets/logo_gpt.png')
                        }, null, 8, _hoisted_11)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => _cache[31] || (_cache[31] = [
                        _createElementVNode("p", null, "ChatGPT", -1)
                      ])),
                      _: 1
                    }),
                    _cache[32] || (_cache[32] = _createElementVNode("p", null, null, -1))
                  ]),
                  _: 1
                }),
                (_ctx.userSLP.waitingGPTResp)
                  ? (_openBlock(), _createElementBlock("b", _hoisted_12, " Thinking..."))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_ion_card_content, { style: {"padding":"0","max-height":"25vh","overflow":"scroll"} }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_ion_item, { lines: "full" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            innerHTML: _ctx.parseMsg(_ctx.currViewingProfession?.explanation)
                          }, null, 8, _hoisted_13)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, _ctx.currViewingProfession?.explanation]
                  ]),
                  _withDirectives(_createVNode(_component_ion_item, { lines: "full" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, "1. " + _toDisplayString(_ctx.currViewingProfession?.point1), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, _ctx.currViewingProfession?.point1]
                  ]),
                  _withDirectives(_createVNode(_component_ion_item, { lines: "full" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, "2. " + _toDisplayString(_ctx.currViewingProfession?.point2), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, _ctx.currViewingProfession?.point2]
                  ]),
                  _withDirectives(_createVNode(_component_ion_item, { lines: "full" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, "3. " + _toDisplayString(_ctx.currViewingProfession?.point3), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, _ctx.currViewingProfession?.point3]
                  ]),
                  _createVNode(_component_ion_item, { lines: "full" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                        default: _withCtx(() => _cache[33] || (_cache[33] = [
                          _createElementVNode("p", { style: {"line-height":"1"} }, [
                            _createElementVNode("small", null, "Disclaimer: The data presented is for reference purposes only. We do not guarantee their correctness, completeness, or timeliness.")
                          ], -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ], 512), [
          [_vShow, _ctx.currStep == 2]
        ]),
        (!_ctx.isReadonly() && _ctx.currStep == 5 && _ctx.selectedSLPType == 'gpt' && !_ctx.userSLP.waitingGPTResp && _ctx.userSLP.gpt)
          ? (_openBlock(), _createBlock(_component_ion_toolbar, {
              key: 0,
              style: {"padding-top":"5px"},
              class: "ion-text-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  style: {"text-transform":"none"},
                  shape: "round",
                  color: "medium",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.regenerateGPTResponse()))
                }, {
                  default: _withCtx(() => [
                    _cache[34] || (_cache[34] = _createTextVNode(" Regenerate response ")),
                    _createVNode(_component_ion_icon, {
                      slot: "end",
                      icon: _ctx.refresh
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_ion_toolbar, { style: {"--min-height":"32px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_ion_col, {
                  class: "ion-no-padding",
                  size: "2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      color: "dark",
                      fill: "clear",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.currStep--))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "icon-only",
                          icon: _ctx.arrowBack
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.currStep > 1]
                ]),
                _withDirectives(_createVNode(_component_ion_col, { class: "ion-no-padding" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      expand: "block",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => {_ctx.currStep = 2; _ctx.getRecommendedProfessionsFromGPT()}),
                      disabled: (!_ctx.user.isAdmin && _ctx.isPreview && _ctx.isReadonly()) || (!_ctx.userSLP.tagId && !_ctx.userSLP.userInputText) || _ctx.userSLP.isInCooldownTime,
                      class: "no-text-transform"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.userSLP.isInCooldownTime ? `Please wait (${_ctx.userSLP.cooldownSecLeft}s)` : `GO`) + " ", 1),
                        _createVNode(_component_ion_icon, {
                          slot: "end",
                          icon: _ctx.arrowForward
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.currStep == 1]
                ]),
                _withDirectives(_createVNode(_component_ion_col, { class: "ion-no-padding" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      expand: "block",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.currStep++))
                    }, {
                      default: _withCtx(() => [
                        _cache[35] || (_cache[35] = _createTextVNode(" Next ")),
                        _createVNode(_component_ion_icon, {
                          slot: "end",
                          icon: _ctx.arrowForward
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.currStep > 1 && _ctx.currStep < 5]
                ]),
                _withDirectives(_createVNode(_component_ion_col, { size: "10" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      style: {"transform":"none"},
                      color: "success",
                      expand: "block",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.sendSLPWhatsAppRecord()))
                    }, {
                      default: _withCtx(() => [
                        _cache[36] || (_cache[36] = _createTextVNode(" Send to My WhatsApp ")),
                        _createVNode(_component_ion_icon, {
                          slot: "end",
                          icon: _ctx.send
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.currStep == 5]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, !_ctx.userSLP.waitingGPTResp]
        ])
      ]),
      _: 1
    })
  ], 64))
}